export enum FileType {
  Excel = 'application/vnd.ms-excel',
  ExcelAlt = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  CSV = 'text/csv',
  PDF = 'application/pdf',
  JPGImage = 'image/jpeg',
  PNGImage = 'image/png',
  SVGImage = 'image/svg+xml',
  DOC = 'application/msword',
  DOCX = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  WEBPImage = 'image/webp',
  Zip = 'application/zip',
  JSON = 'application/json',
}

const fileTypeExtensions = {
  [FileType.Excel]: 'xls',
  [FileType.ExcelAlt]: 'xlsx',
  [FileType.CSV]: 'csv',
  [FileType.PDF]: 'pdf',
  [FileType.JPGImage]: 'jpg',
  [FileType.PNGImage]: 'png',
  [FileType.SVGImage]: 'svg',
  [FileType.DOCX]: 'docx',
  [FileType.DOC]: 'doc',
  [FileType.WEBPImage]: 'webp',
  [FileType.Zip]: 'zip',
  [FileType.JSON]: 'json',
};

export const isFileType = (value: string): value is FileType => {
  return Object.values(FileType).includes(value as FileType);
};

export const getExtensionByType = (fileType: FileType) =>
  fileTypeExtensions[fileType];

export const fetchFile = async (fileUrl: string) => {
  try {
    return await (await fetch(new Request(fileUrl))).arrayBuffer();
  } catch {
    return null;
  }
};

export function convertFileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      resolve(reader.result as string);
    };
    reader.onerror = () => {
      reject(new Error('Failed to convert file to base64'));
    };
  });
}

export function extractBase64FromDataUrl(dataUrl: string): string {
  // Remove the data URL prefix (e.g., "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,")
  const base64Match = /^data:[^;]+;base64,(.+)$/.exec(dataUrl);

  if (!base64Match) {
    throw new Error('Invalid data URL format');
  }
  return base64Match[1];
}

export function convertFileToBase64Content(file: File): Promise<string> {
  return convertFileToBase64(file).then(extractBase64FromDataUrl);
}
